import axiosInstance from '../../utils/axiosConfig';
import axios from 'axios';
import { clearClaims } from './claim';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT = 'LOGOUT';
export const PASSWORD_RESET_REQUEST = 'PASSWORD_RESET_REQUEST';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const PASSWORD_RESET_FAILURE = 'PASSWORD_RESET_FAILURE';
const translateMsgError = async (status) => { 
    switch (status) {
        case 'Invalid password':
            return 'Mot de passe invalide '; 

        case 'Too many failed login attempts. Account is locked':
            return 'Trop de tentatives de connexion échouées. Le compte est verrouillé';

        case 'Account is expired':
            return 'Le compte est expiré, veuillez contacter un administrateur'; 

        case 'Account is locked':
            return 'Le compte est verrouillé, veuillez contacter un administrateur'; 

        case 'User not found':
            return 'Utilisateur non trouvé';  
            
        case 'Invalid identifiers or missing fields':
            return 'Identifiants invalides ou champs manquants';  

        default:
            return status || 'Une erreur inconnue est survenue';
    }
};
export const loginUser = (email, password, redirect) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.post(process.env.REACT_APP_BACKEND_URL_MS_USER+'/loginUser', {
                username: email,
                password: password,
            });

            const userData = response.data;
            const expirationTime = new Date().getTime() + 3600 * 1000; // 1 hour from now
 

            localStorage.setItem('token', userData.token);
            localStorage.setItem('tokenExpiration', expirationTime);
            localStorage.setItem('username', userData.username);
            localStorage.setItem('userId', userData.userId);
            localStorage.setItem('groupAuthorities',JSON.stringify(userData.userGroups));
            localStorage.setItem('userFirstName', userData.firstName);
            localStorage.setItem('userLastName',userData.lastName);
            localStorage.setItem('updatedPassword',userData.updatedPassword);
            localStorage.setItem('passwordExpirationDate',new Date(userData.passwordExpirationDate));
            if (userData.personalAuthorities && userData.personalAuthorities.length > 0) {
                localStorage.setItem('personalAuthorities', JSON.stringify(userData.personalAuthorities));
            }
            dispatch({ type: LOGIN_SUCCESS, payload: userData });
            redirect();
        } catch (error) { 
            const errorMessage = await translateMsgError(error.response.data);
            dispatch({ type: LOGIN_FAILURE, payload: errorMessage });
          }
    };
};

export const logoutUser = () => {
    return (dispatch) => {
        
        const userId = localStorage.getItem('userId'); 
        if (userId) {
            axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_COMMUNICATIONCHANNELS}/api/remove-token`, { userId })
                .then(response => {
                    console.log("Token removed successfully.");
                })
                .catch(error => {
                    console.error("Error removing token:", error);
                });
        }
        localStorage.clear();
        // window.location.reload(true)
        dispatch(clearClaims());
        dispatch({ type: LOGOUT });
    };
};


 
export const updatePassword = async (mdp) => {
    const userId = localStorage.getItem('userId'); 
    const token = localStorage.getItem('token');
    
    if (!token) {
        throw new Error('Token is missing');
    }

    try {
        const response = await axiosInstance.put(`${process.env.REACT_APP_BACKEND_URL_MS_USER}/updatePassword/${userId}`,
            {password: mdp });

        return response.data;
    } catch (error) {
        console.error('Error updating password:', error);
        throw error;
    }
};

export const requestPasswordReset = (email) => {
    return async (dispatch) => {
        try {
            dispatch({ type: PASSWORD_RESET_REQUEST });
            
            const response = await axiosInstance.post(process.env.REACT_APP_BACKEND_URL_MS_USER+'/requestPasswordReset', {
                email: email
            });

            if (response.data.success) {
                dispatch({ type: PASSWORD_RESET_SUCCESS });
                return { success: true };
            } else {
                dispatch({ type: PASSWORD_RESET_FAILURE, payload: response.data.message || 'Failed to send reset code' });
                return { success: false, message: response.data.message };
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || 'An error occurred while requesting password reset';
            dispatch({ type: PASSWORD_RESET_FAILURE, payload: errorMessage });
            throw error;
        }
    };
};

export const resetPassword = (email, verificationCode, newPassword) => {
    return async (dispatch) => {
        try {
            dispatch({ type: PASSWORD_RESET_REQUEST });
            
            const response = await axios.post(process.env.REACT_APP_BACKEND_URL_MS_USER+'/resetPassword', {
                email: email,
                verificationCode: verificationCode,
                newPassword: newPassword
            });

            if (response.data.success) {
                dispatch({ type: PASSWORD_RESET_SUCCESS });
                return { success: true };
            } else {
                dispatch({ type: PASSWORD_RESET_FAILURE, payload: response.data.message || 'Failed to reset password' });
                return { success: false, message: response.data.message };
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || 'An error occurred while resetting password';
            dispatch({ type: PASSWORD_RESET_FAILURE, payload: errorMessage });
            throw error;
        }
    };
};

 
